var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0148 8.72467C18.0137 8.60905 17.9811 8.4959 17.9207 8.39731C17.8603 8.29873 17.7742 8.2184 17.6717 8.16492L1.8722 0.490868C1.75163 0.427442 1.61393 0.404252 1.47924 0.424687C1.34454 0.445123 1.21991 0.508113 1.12358 0.604447C1.02725 0.700781 0.964257 0.825406 0.943821 0.960102C0.923386 1.0948 0.946576 1.2325 1.01 1.35307L4.91474 8.72467L0.991946 16.0782C0.924963 16.2032 0.901472 16.3468 0.925175 16.4866C0.948878 16.6264 1.01843 16.7543 1.12286 16.8501V16.8501C1.21654 16.9431 1.33673 17.0047 1.46688 17.0265C1.59703 17.0484 1.73075 17.0293 1.84963 16.972L17.6491 9.29797C17.7579 9.24657 17.85 9.16548 17.9146 9.06405C17.9793 8.96262 18.0141 8.84497 18.0148 8.72467V8.72467ZM3.05491 14.9722L6.02522 9.36568H9.24832C9.3325 9.36568 9.41585 9.3491 9.49362 9.31689C9.57139 9.28467 9.64206 9.23746 9.70158 9.17793C9.7611 9.11841 9.80832 9.04775 9.84053 8.96997C9.87275 8.8922 9.88933 8.80885 9.88933 8.72467C9.88933 8.64049 9.87275 8.55714 9.84053 8.47937C9.80832 8.4016 9.7611 8.33093 9.70158 8.27141C9.64206 8.21189 9.57139 8.16467 9.49362 8.13246C9.41585 8.10024 9.3325 8.08366 9.24832 8.08366L6.02522 8.08366L3.05491 2.47709L15.9112 8.72467L3.05491 14.9722Z",
    fill: "white",
    fillOpacity: 0.32
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledIcon);
export default __webpack_public_path__ + "static/media/disabledIcon.1d249a4fe69c7be68027bafc3c3f4ddf.svg";
export { ForwardRef as ReactComponent };